import { useHttpClient } from "@/common/api/httpClient";
import type { StorageAreaResponse } from "./models/storageAreaResponse";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";
import type { StorageAreaRequest } from "./models/storageAreaRequest";
import { useStorageAreaStore } from "shared/storageAreas/stores/storageAreaStore";

export interface UpdateStorageAreaRequest {
  id: string;
  storageArea: StorageAreaRequest;
}

export interface UpdateStorageAreaResponse {
  ok: true;
  storageArea: StorageAreaResponse;
}

export function useUpdateStorageArea() {
  const httpClient = useHttpClient();
  const store = useStorageAreaStore();

  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: UpdateStorageAreaRequest) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`storagearea/${action.id}`), {
      headers,
      method: 'PUT',
      body: JSON.stringify(action.storageArea)
    });

    const text = translations.value.storageAreas.actions.update;

    const response = await httpClient.action<UpdateStorageAreaResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as StorageAreaResponse;
        store.add(json);
        return {
          ok: true,
          storageArea: json
        };
      },
    });

    return response;
  }
}
